export default __webpack_public_path__ + "static/media/noImage.908b8bae.svg";